import {useTranslation} from '@aboutyou/i18n';
import {
  Banner,
  COLORS,
  GenericIconName,
  Icon,
  RADIUS,
  SPACING,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import couponBackground from './assets/bannerBackground.svg';
import {useShouldShowCouponLoginBanner} from './hooks/useCouponLoginBanner';

export const InfoBanner = () => {
  const {t} = useTranslation();
  const shouldShowCouponLoginBanner = useShouldShowCouponLoginBanner();

  if (!shouldShowCouponLoginBanner) {
    return null;
  }

  return (
    <StatusRegion role="status" aria-live="polite" aria-atomic="true">
      <StyledCouponBanner
        dataTestid={'couponLoginInfoModal'}
        backgroundColor={COLORS['Coupon.Quaternary']}
      >
        <ContentWrapper>
          <CouponIconWrapper aria-hidden="true">
            <Icon
              size={'S'}
              asset={GenericIconName.Coupon}
              fill={COLORS.PrimaryCoupon}
            />
          </CouponIconWrapper>
          <TextContent>
            <Headline size="px16" weight="bold" color="Coupon.Primary">
              {t('This coupon is just for you 🎉')}
            </Headline>
            <Subline size="px12" weight="mediumBold" color="Coupon.Primary">
              {t('Log in now to access your discounts')}
            </Subline>
          </TextContent>
        </ContentWrapper>
      </StyledCouponBanner>
    </StatusRegion>
  );
};

const StatusRegion = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 0 ${SPACING['X.Xl2']};
  width: 100%;
  margin-top: ${SPACING['Y.Xl']};
`;

const StyledCouponBanner = styled(Banner)`
  border-radius: ${RADIUS.Md};
  overflow: hidden;
  padding: 0;
  max-height: none;
  max-width: 360px;
  width: 100%;
  background-image: url(${couponBackground});
  background-repeat: no-repeat;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${SPACING['X.Md']};
  padding: ${SPACING['Y.Lg']};
  width: 100%;
`;

const TextContent = styled.div`
  color: ${COLORS['Coupon.Primary']};
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

const CouponIconWrapper = styled.div`
  align-items: center;
  background-color: ${COLORS['Coupon.Primary']};
  border-radius: ${RADIUS.Round};
  display: flex;
  flex-shrink: 0;
  height: ${SPACING['Y.Xl3']};
  justify-content: center;
  width: ${SPACING['X.Xl3']};

  svg {
    fill: ${COLORS['Text.White']};
    width: ${SPACING['X.Xl']};
    height: ${SPACING['Y.Xl']};
  }
`;

const Headline = styled(Text)`
  margin: 0;
`;

const Subline = styled(Text)`
  margin: 0;
`;
